import { Image } from 'components/Image/Image';

export const TIME_SENSITIVE = 'TIME_SENSITIVE';
export const CUSTOM_CREDIT_MONITORING = 'CUSTOM_CREDIT_MONITORING';
export const NOTIFICATION_DANGER = 'DANGER';
export const NOTIFICATION_INFO = 'INFO';
export const NOTIFICATION_SUCCESS = 'SUCCESS';

// this are banner types , not banner modes
export const NOTIFICATION_CREDIT_USAGE = 'ACCOUNT_USAGE_GT_50';
export const NOTIFICATION_HIGH_USAGE_ACCOUNT = 'FIRST_TIME_HIGH_USAGE';
export const NOTIFICATION_QUATERLY_REPORT = 'QUARTERLY_REPORT';

export const NOTIFICATION_TYPE = {
  [TIME_SENSITIVE]: 'TIME SENSITIVE',
  [CUSTOM_CREDIT_MONITORING]: 'TIME SENSITIVE',
};

export const NOTIFICATION_DETAIL = {
  [NOTIFICATION_DANGER]: {
    text: 'Take action now to minimize any impact to your credit score',
    icon: <Image imgClass={'exclamation'} />,
    linkText: 'View details in app',
  },
  [NOTIFICATION_INFO]: {
    text: 'Your account is marked 30 days late. Take action now to prevent it from going 60/90',
    icon: <Image imgClass={'warning'} />,
    linkText: 'View details in app',
  },
  [NOTIFICATION_SUCCESS]: {
    text: 'Congratulations! Your account is now current',
    icon: <Image imgClass={'balloons'} />,
    linkText: 'View details in app',
  },
  [NOTIFICATION_CREDIT_USAGE]: {
    text: 'Take action now to minimize any impact to your credit score',
    icon: <Image imgClass={'warning'} />,
    linkText: 'View time sensitive notifications',
  },
  [NOTIFICATION_HIGH_USAGE_ACCOUNT]: {
    icon: <Image imgClass={'warning'} />,
  },

  [CUSTOM_CREDIT_MONITORING]: {
    icon: <Image imgClass={'warning'} />,
  },
  [NOTIFICATION_QUATERLY_REPORT]: {
    icon: <Image imgClass={'quarterlyReport'} />,
    linkText: 'View my Quarterly Report',
    bannerTitle: 'NEW REPORT',
  },
};
